"use client";

interface ResultCardProps {
  label: string;
  value: string | number;
  unit?: string;
  sub?: string;
  accent?: boolean;      // primary result highlight
  highlight?: boolean;   // secondary metric success green
  size?: "sm" | "md" | "lg";
}

/* eslint-disable @typescript-eslint/no-unused-vars */
export default function ResultCard({
  label,
  value,
  unit,
  sub,
  accent = false,
  highlight = false,
  size = "md",
}: ResultCardProps) {
  const valueColor = "text-[var(--accent)] font-bold";

  return (
    <div className="py-3.5 border-b border-[var(--line)] last:border-b-0 flex flex-col gap-1 w-full">
      <div className="flex justify-between items-baseline w-full">
        <span className="font-mono text-xs uppercase tracking-wider text-[var(--ink-soft)] select-none">
          {label}
        </span>
        <div className="flex items-baseline gap-1">
          <span className={`font-mono text-[22px] ${valueColor} tabular-nums`}>
            {value}
          </span>
          {unit && (
            <span className="text-xs text-[var(--ink-faint)] font-mono lowercase ml-1">
              {unit}
            </span>
          )}
        </div>
      </div>
      {sub && (
        <span className="text-[11px] text-[var(--ink-faint)] font-mono leading-relaxed text-left">
          {sub}
        </span>
      )}
    </div>
  );
}
